import { Fragment } from 'react'
import AppStyleDecider from '../../../../../../../../../../baseComponents/AppsStyleDecider'
import { OrderStepButtonsBaseComponentProps } from '../../../../../../../../../../specificComponents/inputTableLayouts/order/OrderLayout/OrderButtonsBaseComponent/types'
import BuyDeliveryNoteStatusBar, { BuyDeliveryNoteStatusBarNew, DeliveryNoteCreateStatusBarProps } from '../../../BuyDeliveryNoteStatusBar'
import BuyDeliveryNoteCreateStepButtons, { BuyDeliveryNoteCreateStepButtonsNew } from '../BuyDeliveryNoteCreateStepButtons'

type BuyDeliveryNoteCreateStepHeaderProps = & DeliveryNoteCreateStatusBarProps & OrderStepButtonsBaseComponentProps

const BuyDeliveryNoteCreateStepHeaderDecider: React.FC<BuyDeliveryNoteCreateStepHeaderProps> = ({ ...rest }) => {
    return (
        <AppStyleDecider DefaultComponent={BuyDeliveryNoteCreateStepHeaderDefault} NewComponent={BuyDeliveryNoteCreateStepHeaderNew} {...rest} />
    )
}

const BuyDeliveryNoteCreateStepHeaderDefault: React.FC<BuyDeliveryNoteCreateStepHeaderProps> = ({ ...rest }) => {
    return (
        <div className='flex gap-10 justify-between flex-wrap items-center flex-auto'>
            <BuyDeliveryNoteStatusBar {...rest} />
            <BuyDeliveryNoteCreateStepButtons {...rest} />
        </div>
    )
}

const BuyDeliveryNoteCreateStepHeaderNew: React.FC<BuyDeliveryNoteCreateStepHeaderProps> = ({ ...rest }) => {
    return (
        <Fragment>
            <BuyDeliveryNoteStatusBarNew {...rest} />
            <BuyDeliveryNoteCreateStepButtonsNew {...rest} />
        </Fragment>
    )
}

export default BuyDeliveryNoteCreateStepHeaderDecider